// extracted by mini-css-extract-plugin
module.exports = {"sortIcon":"styles_sortIcon__33FZF"};